<template>
    <v-card dense class="rouded-4">
        <v-toolbar flat height="45px">
            <span class="font-weight-bold">Workshift Color</span>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="closeDialog">
                <v-icon >close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-card-text dense>
            <v-layout row wrap class="border">
                <v-alert v-if="error" :value="true" color="error" icon="error" outline>
                    Error encountered. Please contact support. Error details: {{errorMessage}}
                </v-alert>
                <v-flex xs12 sm12>
                    <div class="color-group-container">
                        <b>Choose a color group</b>
                        <div class="container">
                            <div
                                v-for="item1 in colorGroups"
                                :key="item1.name"
                                class="color-div"
                                :title="item1.description"
                                @click="displayColorList(item1.name)"
                                :style="`background-color:${item1.hex}`">
                            </div>
                        </div>
                        <b>Select a color</b>
                        <div class="container">
                            <div
                                v-for="item2 in colorList"
                                :key="item2.hex"
                                class="color-div"
                                :title="item2.description"
                                @click="selectColor(item2.hex)"
                                :style="`background-color:${item2.hex}`">
                            </div>
                        </div>
                    </div>
                </v-flex>  
            </v-layout> 
        </v-card-text>
    </v-card>
</template>
<script>

import colorsApi from '@/api/colors'

export default {
    data() {
        return {
            error: false,
            errorMessage: '', 
            loading: false,
            colors: [],
            colorName: null,
        }
    },
    methods: {
        async getColors() {
            try {
                this.loading = true
                const response = await colorsApi.getForWorkShifts()
                if (response && response.status == 200) {
                    this.colors = response.data.colors
                }
                this.loading = false
            }catch(error) {
                this.error = true
                this.errorMessage = error
            }
        },
        selectColor(hex) {
            this.$emit('send', hex)
            this.closeDialog()
        },
        displayColorList(name) {
            this.colorName = name
        },
        closeDialog() {
            this.$emit('update:dialogColorPicker', false)
        }
    },
    created() {
        this.getColors()
    },
    computed: {
        colorGroups() {
            if (!this.loading) {
                return this.colors
                    .filter(x => x.shadeType == 0)
                    .map(x => {
                        return {
                            name: x.name,
                            hex: x.hex
                        }
                    })
            }
        },
        colorList() {
            const filter = this.colorName ? this.colorName : 'red';
            return this.colors
                    .filter(x => x.name == filter)
                    .sort((a, b) => a.description.localeCompare(b.description))
                    .map(x => {
                        return {
                            description: x.description,
                            hex: x.hex
                        }
                    });
        }
    },
}
</script>
<style scoped>
.border {
    padding: 0px 10px 10px 10px;
}
.color-group-container {
    margin: 0px 20px 20px 10px;
}
.color-group {
    width: 100%;
    border: 1px solid transparent;
}
/* container for colors */
.container {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
}
/* color box */
.color-div {
    width: 35px;
    height: 35px;
    border-radius: 4px;
    cursor: pointer;
    box-sizing: border-box;
    flex: 0 0 auto; /* prevents stretching */
}
/* mobile adjustments */
@media (max-width: 768px) {
    .color-group-container {
        margin: 0px 10px 15px 10px;
    }
    .color-div {
        width: 32px;
        height: 32px;
    }
}
</style>